import React, { useEffect, useState } from "react";
import BackArrow from "../../resources/icons/chevron-left.svg";
import EntityConstants from "../../configs/EntityConstants";

import { useNavigate, useParams } from "react-router-dom";
import { GET } from "../../service/CRUDService";
import DownloadFile from "../../service/DownloadFile";
import Toast from "../../common/Toast/Toast";

import Download from "../../resources/icons/download-01.svg";
import DownloadDisabled from "../../resources/icons/download-01-disabled.svg";
import BackArrowSquare from "../../resources/icons/arrow-square-up-right.svg";
import DotMoreOptions from "../../resources/icons/dots-horizontal.svg";
import DiabledDotMoreOptions from "../../resources/icons/disabled-dots-horizontal.svg";
import BackArrowSquareDisabled from "../../resources/icons/arrow-square-up-right-disabled.svg";
import CredentialPreviewModal from "../../common/CredentialPreviewModal/CredentialPreviewModal";
import CredentialRevokeModal from "../../common/CredentialRevokeModal/CredentialRevokeModal";
import revokeButton from "../../resources/icons/revokeButton.svg";
import disabledRevokeButton from "../../resources/icons/disabledRevokeButton.svg";
import JsonPreviewModal from "../../common/JsonPreviewModal/JsonPreviewModal";
import { Menu } from "@headlessui/react";
import DownloadRequestModal from "../../common/DownloadRequestModal/DownloadRequestModal";
import NotificationModal from "../../common/NotificationModal/NotificationModal";
import PrintIcon from "../../resources/icons/printer.svg";
import PrintIconDisabled from "../../resources/icons/printer-disabled.svg";
import PrintModal from "../../common/PrintModal/PrintModal";
import { File, RefreshCw, DownloadIcon } from "lucide-react";
import useNavigationStore from "../../store/navigationStore";
import userIcon from "../../resources/icons/user-icon.svg";
import CredentialsDetails from "../../components/DashboardPageComponents/CredentialsDetails";
import DownloadFileCustomName from "../../utils/DownloadFileCustomName";

const BATCH_TRANSACTION_POLLING_TIME_INTERVAL = 5000;
const BatchTransaction = () => {
  const navigate = useNavigate();
  const { transaction_id } = useParams();

  const { setProgramme, setBatch } = useNavigationStore();

  const [count, setCount] = useState(0);
  const [offset, setOffset] = useState(0);
  const [limit] = useState(10);

  const [isOpen, setIsOpen] = useState(false);
  const [isOpenJSON, setIsOpenJSON] = useState(false);
  const [currentCredentialId, setCurrentCredentialId] = useState(null);
  const [currentCredentialIdJsonModal, setCurrentCredentialIdJsonModal] =
    useState(null);
  // const [currentCredentialIdNotification, setCurrentCredentialIdNotification] = useState(null);
  // const [printScreen, setPrintScreen] = useState(false); // !This is for print

  const [detailsList, setDetailsList] = useState([]);
  const [programmeId, setProgrammeId] = useState(null);
  const [batchId, setBatchId] = useState(null);
  const [credentialTemplateId, setCredentialTemplateId] = useState(null);
  const [issuerCredentialTemplateId, setIssuerCredentialTemplateId] =
    useState(null);
  const [templateType, setTemplateType] = useState(null);

  const [, setIsLoadingcontentList] = useState(true);
  const [previous, setPrevious] = useState(null);
  const [next, setNext] = useState(null);
  const [isStatus, setIsStatus] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(null);
  const [dataLoadCount, setDataLoadCount] = useState(0);
  const [title, setTitle] = useState("");
  const [notificationShowModal, setNotificationShowModal] = useState(null);
  const [isDownloadRequestModalOpen, setIsDownloadRequestModalOpen] =
    useState(false);
  const [downloadRequestModalMessage, setDownloadRequestModalMessage] =
    useState("");
  const [downloadRequestModalHeader, setDownloadRequestModalHeader] =
    useState("");
  const [isDownloadRequestSuccess, setIsDownloadRequestSuccess] =
    useState(false);
  const [isPrintModalOpen, setIsPrintModalOpen] = useState(false);
  const [currentPrintCredential, setCurrentPrintCredential] = useState(null);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [totalRecipients, setTotalRecipients] = useState(0);
  const [excelData, setExcelData] = useState(null);
  const [zipData, setZipData] = useState(null);
  const [excelFileName, setExcelFileName] = useState(null);
  const [zipFileName, setZipFileName] = useState(null);

  const toggleModal = (credential_id) => {
    setIsModalOpen(credential_id);
  };

  useEffect(() => {
    transaction_id && GET_ALL_TRANSACTIONS_LIST(limit, offset);
  }, [transaction_id]);

  const formatStatus = (status) => {
    if (!status) return "Unavailable";
    return status
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  const GET_ALL_TRANSACTIONS_LIST = async (limit, offset) => {
    try {
      setIsRefreshing(true);
      const response = await GET(
        `${EntityConstants.GET_USER_BULK_TRANSACTION_DETAILS}/${transaction_id}?offset=${offset}&limit=${limit}&statuses=Failed,Revoked,Issued,Notified,Printed,Printed_and_Notified`
      );

      if (response.ok) {
        const data = await response.json();
        count !== data.count && setCount(data.count);
        setOffset(offset);
        setDetailsList([...data.results]);
        setProgrammeId(data.programme_code);
        setBatchId(data.batch_code);
        setCredentialTemplateId(data.credential_template_id);
        setIssuerCredentialTemplateId(data.issuer_credential_template_id);
        setTemplateType(data.template_type);
        dataLoadCount < 1 && setTitle([data.results[0].certificate_name]);
        setPrevious(data.previous);
        setNext(data.next);
        setIsStatus(data.status);
        setTotalRecipients(data.number_of_recipient);
        setExcelData(data.excel_data.file_url);
        setZipData(data.zip_file_path.file_url);
        setExcelFileName(data.excel_data.file_name);
        setZipFileName(data.zip_file_path.file_name);
        data.results.length !== 0 && setIsLoadingcontentList(false);

        setProgramme({ programme_code: data.programme_code });
        setBatch({ batch_code: data.batch_code });
      } else {
        console.log(response?.error);
        Toast({
          type: "error",
          title: "Error",
          message: response?.message,
        });
      }
    } catch (error) {
      console.error("Failed to fetch bulk data:", error);
    } finally {
      setIsRefreshing(false);
    }
  };

  const handleRefresh = async () => {
    await GET_ALL_TRANSACTIONS_LIST(limit, offset);
  };

  const CtaList = (status) => [
    {
      name: "BackArrowSquare",
      iconActive: (
        <img src={BackArrowSquare} alt="" srcSet="" title="Preview" />
      ),
      iconDisabled: <img src={BackArrowSquareDisabled} alt="" srcSet="" />,
      onClick: (credential_id) => {
        openCloseModal(credential_id);
      },
      disabled: status === "Failed",
    },
    {
      name: "Download",
      iconActive: <img src={Download} alt="" srcSet="" title="Download" />,
      iconDisabled: <img src={DownloadDisabled} alt="" srcSet="" />,
      onClick: (credential_id) =>
        DownloadFile(EntityConstants.DOWNLOAD_SVG_AS_PNG, credential_id),
      disabled: status === "Failed",
    },
    {
      name: "Revoke",
      iconActive: (
        <img
          src={revokeButton}
          height={27}
          width={27}
          alt=""
          srcSet=""
          title="Revoke"
        />
      ),
      iconDisabled: (
        <img
          src={disabledRevokeButton}
          height={27}
          width={27}
          alt=""
          srcSet=""
        />
      ),
      onClick: (credential_id) => {
        toggleModal(credential_id);
      },
      disabled: status === "Revoked" || status === "Failed",
    },
    {
      name: "Print",
      iconActive: (
        <img
          src={PrintIcon}
          alt=""
          height={27}
          width={27}
          srcSet=""
          title="Print"
        />
      ),
      iconDisabled: (
        <img src={PrintIconDisabled} alt="" height={27} width={27} srcSet="" />
      ),
      onClick: (credential_id) => {
        const credential = detailsList.find(
          (c) => c.credential_id === credential_id
        );
        setCurrentPrintCredential(credential);
        setIsPrintModalOpen(true);
      },
      disabled: status === "Failed" || status === "Revoked",
    },
  ];

  const handleDownloadZip = async (event) => {
    event.stopPropagation();
    await DownloadFile(
      EntityConstants.DOWNLOAD_SVG_AS_ZIP,
      transaction_id,
      true,
      showMessageModal
    );
  };

  const showMessageModal = (isSuccess, status, message) => {
    setIsDownloadRequestSuccess(isSuccess);
    setDownloadRequestModalHeader(status);
    setDownloadRequestModalMessage(message);
    setIsDownloadRequestModalOpen(true);
  };

  const openCloseModal = (credential_id) => {
    if (isOpen && currentCredentialId === credential_id) {
      setIsOpen(false);
      setCurrentCredentialId(null);
    } else {
      setIsOpen(true);
      setCurrentCredentialId(credential_id);
    }
  };

  const openCloseJsonModal = (credential_id) => {
    if (isOpenJSON && currentCredentialIdJsonModal === credential_id) {
      setIsOpenJSON(false);
      setCurrentCredentialIdJsonModal(null);
    } else {
      setIsOpenJSON(true);
      setCurrentCredentialIdJsonModal(credential_id);
    }
  };

  const navigateSummaryPage = () => {
    navigate(
      `/issuer/workspace/batches/summary/${credentialTemplateId}/${issuerCredentialTemplateId}?templateType=${templateType}`
    );
  };

  useEffect(() => {
    let pollingInterval;
    if (
      detailsList.some((credential) => !credential.status) ||
      detailsList.length < 1 ||
      isStatus === "In Progress"
    ) {
      pollingInterval = setInterval(() => {
        setDataLoadCount((prev) => prev + 1);
        GET_ALL_TRANSACTIONS_LIST(limit, offset);
      }, BATCH_TRANSACTION_POLLING_TIME_INTERVAL); // 5-second interval
    }
    return () => {
      clearInterval(pollingInterval); // Clear interval on cleanup
    };
  }, [detailsList, offset]);

  return (
    <div className="mt-20 bg-cfSecondary min-h-screen">
      <div className="flex w-full justify-between py-[2rem] px-[0.75rem]">
        <div className=" flex items-center text-[#101828] font-bold ">
          <button
            className="flex items-center focus:outline-none"
            onClick={() => navigate(-1)}
            aria-label="Go back"
          >
            <img src={BackArrow} alt="" className="pointer-events-none" />
          </button>
          <p>{title}</p>
        </div>
        <div className="flex gap-2">
          {programmeId &&
            batchId &&
            credentialTemplateId &&
            issuerCredentialTemplateId &&
            templateType && (
              <button
                className="cursor-pointer py-2.5 px-3 rounded-[8px] font-medium bg-cfPrimaryButton text-cfSecondary"
                onClick={navigateSummaryPage}
              >
                View Template Summary
              </button>
            )}

          {count > 1 && (
            <button
              onClick={(e) => handleDownloadZip(e)}
              className="cursor-pointer py-2.5 px-3 rounded-[8px] font-medium bg-cfPrimaryButton text-cfSecondary"
            >
              <p>Download all certificates</p>
            </button>
          )}
          <button
            onClick={handleRefresh}
            disabled={isRefreshing}
            className={`px-3 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50 transition-colors flex items-center gap-2 ${
              isRefreshing ? "opacity-50 cursor-not-allowed" : ""
            }`}
          >
            <RefreshCw
              className={`h-4 w-4 ${isRefreshing ? "animate-spin" : ""}`}
            />
            <span>Refresh</span>
          </button>
        </div>
      </div>
      <DownloadRequestModal
        isOpen={isDownloadRequestModalOpen}
        header={downloadRequestModalHeader}
        message={downloadRequestModalMessage}
        isSuccess={isDownloadRequestSuccess}
        onClose={() => setIsDownloadRequestModalOpen(false)}
      />
      {isModalOpen && (
        <CredentialRevokeModal
          isModalOpen={isModalOpen}
          toggleModal={toggleModal}
          GET_ALL_TRANSACTIONS_LIST={() =>
            GET_ALL_TRANSACTIONS_LIST(limit, offset)
          }
        />
      )}

      {detailsList.length === 0 ? (
        <div className="px-6 pb-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="relative flex flex-col min-w-0 break-words bg-white shadow-xl border border-[#E0EAFF] rounded-2xl p-6 animate-pulse">
              <div className="flex flex-row items-center justify-between pb-2">
                <div className="h-5 bg-gray-200 rounded-full w-1/3"></div>
              </div>
              <div className="flex items-center space-x-4">
                <div className="rounded-full bg-gray-200 h-12 w-12"></div>
                <div className="flex-1">
                  <div className="h-4 bg-gray-200 rounded w-3/4"></div>
                  <div className="h-6 bg-gray-200 rounded mt-2 w-1/2"></div>
                </div>
              </div>
            </div>

            <div className="relative flex flex-col min-w-0 break-words bg-white shadow-xl border border-[#E0EAFF] rounded-2xl p-6 animate-pulse">
              <div className="flex flex-row items-center justify-between pb-2">
                <div className="h-5 bg-gray-200 rounded-full w-1/3"></div>
              </div>
              <div className="flex items-center space-x-4">
                <div className="flex-1">
                  <div className="h-4 bg-gray-200 rounded w-3/4"></div>
                  <div className="h-6 bg-gray-200 rounded mt-2 w-1/2"></div>
                </div>
              </div>
            </div>

            <div className="relative flex flex-col min-w-0 break-words bg-white shadow-xl border border-[#E0EAFF] rounded-2xl p-6 animate-pulse">
              <div className="flex flex-row items-center justify-between pb-2">
                <div className="h-5 bg-gray-200 rounded-full w-1/3"></div>
              </div>
              <div className="flex items-center space-x-4">
                <div className="flex-1">
                  <div className="h-4 bg-gray-200 rounded w-3/4"></div>
                  <div className="h-6 bg-gray-200 rounded mt-2 w-1/2"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="px-6 pb-6">
          <div
            className={`grid gap-6 ${
              [
                true,
                !!(excelFileName && excelData),
                !!(zipFileName && zipData),
              ].filter(Boolean).length === 1
                ? "grid-cols-1"
                : [
                    true,
                    !!(excelFileName && excelData),
                    !!(zipFileName && zipData),
                  ].filter(Boolean).length === 2
                ? "grid-cols-1 md:grid-cols-2"
                : "grid-cols-1 md:grid-cols-3"
            }`}
          >
            <CredentialsDetails
              credentialDescription={`${
                totalRecipients === 1 ? "Total Recipient" : "Total Recipients"
              }`}
              credentialNumber={totalRecipients}
              imageSrc={userIcon}
              backgroundColor="#E0EAFF"
              borderStyling={`border border-[#E0EAFF] ${
                !(excelFileName && excelData) && !(zipFileName && zipData)
                  ? "w-[35rem]"
                  : ""
              }`}
            />
            {excelFileName && excelData && (
              <div className="relative flex flex-col min-w-0 break-words bg-white shadow-xl border border-[#E0EAFF] rounded-2xl p-6">
                <div className="flex flex-row items-center justify-between pb-2">
                  <h5 className="font-bold dark:text-gray-800">
                    {totalRecipients === 1 ? "Recipient" : "Recipients"} Data
                  </h5>
                </div>
                <div className="flex items-center justify-between mt-2">
                  <div className="flex items-center min-w-0">
                    {" "}
                    <File className="h-4 w-4 text-blue-600 mr-2 flex-shrink-0" />
                    <span className="text-sm font-medium text-gray-900 truncate">
                      {excelFileName ? excelFileName : "No file available"}
                    </span>
                  </div>
                  <button
                    onClick={() =>
                      DownloadFileCustomName(excelData, excelFileName)
                    }
                    className="flex-shrink-0 cursor-pointer"
                    aria-label={`Download ${excelFileName}`}
                  >
                    <DownloadIcon className="h-4 w-4 text-gray-600" />
                  </button>
                </div>
              </div>
            )}
            {zipFileName && zipData && (
              <div className="relative flex flex-col min-w-0 break-words bg-white shadow-xl border border-[#E0EAFF] rounded-2xl p-6">
                <div className="flex flex-row items-center justify-between pb-2">
                  <h5 className="font-bold dark:text-gray-800">
                    {totalRecipients === 1
                      ? "Recipient Certificate"
                      : "Recipients Certificates"}
                  </h5>
                </div>
                <div className="flex items-center justify-between mt-2">
                  <div className="flex items-center min-w-0">
                    {" "}
                    <File className="h-4 w-4 text-blue-600 mr-2 flex-shrink-0" />
                    <span className="text-sm font-medium text-gray-900 truncate">
                      {zipFileName ? zipFileName : "No file available"}
                    </span>
                  </div>
                  <button
                    onClick={() => DownloadFileCustomName(zipData, zipFileName)}
                    className="flex-shrink-0 cursor-pointer"
                    aria-label={`Download ${zipFileName}`}
                  >
                    <DownloadIcon className="h-4 w-4 text-gray-600" />
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      <div className="overflow-x-auto z-10 pb-8">
        {detailsList.length === 0 && (
          <table className="w-full text-sm text-left rtl:text-right text-gray-500">
            <thead className="text-xs text-cfTableHeaderText font-bold bg-[#E0EAFF]">
              <tr>
                <th scope="col" className="px-6 py-3">
                  Name
                </th>
                <th scope="col" className="px-6 py-3">
                  Email ID
                </th>
                <th scope="col" className="px-6 py-3">
                  Phone number
                </th>
                <th scope="col" className="px-6 py-3">
                  Status
                </th>
                <th scope="col" className="px-6 py-3">
                  Preview, Download, Revoke and Print
                </th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b hover:bg-[#F9FAFB]">
                <th
                  scope="row"
                  className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap animate-pulse"
                >
                  Loading . . .
                </th>
                <td className="px-6 py-4 animate-pulse whitespace-nowrap ">
                  Loading . . .
                </td>
                <td className="px-6 py-4 animate-pulse whitespace-nowrap ">
                  Loading . . .
                </td>
                <td className=" py-4">
                  <p
                    className={`w-fit font-semibold text-[#EBF8E7] px-[1.125rem] ml-2.5 py-[0.125rem] text-cfSecondary rounded-full bg-gray-300 animate-pulse whitespace-nowrap`}
                  >
                    Loading . . .
                  </p>
                </td>
                <td className="px-7 py-4">
                  <div className="flex items-center gap-[2.125rem]">
                    {CtaList(detailsList.status).map(
                      ({ iconDisabled }, index) => (
                        <div
                          className="flex items-center gap-[0.5rem] w-6 cursor-not-allowed"
                          key={index}
                        >
                          {iconDisabled}
                        </div>
                      )
                    )}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        )}
        {detailsList.length > 0 && (
          <table className="w-full text-sm text-left rtl:text-right text-gray-500 z-20">
            <thead className="text-xs text-cfTableHeaderText font-bold bg-[#E0EAFF]">
              <tr>
                <th scope="col" className="px-6 py-3 text-center">
                  Name
                </th>
                <th scope="col" className="px-6 py-3 text-center">
                  Email ID
                </th>
                <th scope="col" className="px-6 py-3">
                  Phone number
                </th>
                <th scope="col" className="px-6 py-3">
                  Status
                </th>
                <th scope="col" className="px-6 py-3">
                  Preview, Download, Revoke and Print
                </th>
              </tr>
            </thead>
            <tbody>
              {detailsList.map(
                (
                  {
                    credential_id,
                    approved_by,
                    issuer_name,
                    org_name,
                    public_verify_url,
                    email_id,
                    mobile_number,
                    recipient_name,
                    status,
                    updated_at,
                    svg_url,
                    thumbnail_url,
                    whatsapp_number,
                    legacy_pdf,
                  },
                  index
                ) => (
                  <tr
                    className="border-b hover:bg-[#F9FAFB]"
                    key={credential_id}
                  >
                    <th
                      scope="row"
                      className="px-6 py-4 text-center font-medium text-gray-900 whitespace-nowrap"
                    >
                      {recipient_name ? (
                        recipient_name
                      ) : (
                        <span className="w-fit font-semibold text-[#EBF8E7] px-[1.125rem]  py-[0.125rem] text-cfSecondary rounded-full bg-gray-300">
                          Unavailable
                        </span>
                      )}
                    </th>
                    <td className="px-6 py-4 text-center">
                      {email_id ? (
                        email_id
                      ) : (
                        <span className="w-fit font-semibold text-[#EBF8E7] px-[1.125rem]  py-[0.125rem] text-cfSecondary rounded-full bg-gray-300">
                          Unavailable
                        </span>
                      )}
                    </td>
                    <td className="px-6 py-4">
                      {mobile_number ? (
                        mobile_number
                      ) : (
                        <span className="w-fit font-semibold text-[#EBF8E7] px-[1.125rem]  py-[0.125rem] text-cfSecondary rounded-full bg-gray-300">
                          Unavailable
                        </span>
                      )}
                    </td>
                    <td className=" py-4">
                      <p
                        className={`w-fit font-semibold text-[#EBF8E7] px-[1.125rem] ml-2.5 py-[0.125rem] text-cfSecondary rounded-full ${
                          status === "Issued"
                            ? "bg-cfIssuedCredentialTemplateCardStatusDoneBG"
                            : status === "Failed"
                            ? "bg-cfIssuedCredentialTemplateCardStatusUnderReviewBG"
                            : status === "Revoked"
                            ? "bg-cfIssuedCredentialTemplateCardStatusRevokedBG"
                            : status === "Notified"
                            ? "bg-cfIssuedCredentialTemplateCardStatusDoneBG"
                            : status === "Printed"
                            ? "bg-cfIssuedCredentialTemplateCardStatusDoneBG"
                            : status === "Printed_and_Notified"
                            ? "bg-cfIssuedCredentialTemplateCardStatusDoneBG"
                            : !status && " bg-gray-300 "
                        }`}
                      >
                        {formatStatus(status)}
                      </p>
                    </td>
                    <td className="px-6 py-4 z-50">
                      <div className="flex items-center gap-[2.125rem]">
                        {CtaList(status).map(
                          (
                            { iconActive, iconDisabled, onClick, disabled },
                            index
                          ) => (
                            <button
                              className={`flex items-center gap-[0.5rem] w-6 z-100 ${
                                disabled
                                  ? "cursor-not-allowed"
                                  : "cursor-pointer"
                              }`}
                              key={index}
                              onClick={
                                !disabled ? () => onClick(credential_id) : null
                              }
                            >
                              {disabled ? iconDisabled : iconActive}
                            </button>
                          )
                        )}
                        <Menu as="div" className="relative ">
                          <div>
                            <Menu.Button
                              className={`flex max-w-xs items-center text-md text-cfNavBarText focus:outline-none pr-4 ${
                                status === "Failed"
                                  ? "cursor-not-allowed"
                                  : "cursor-pointer"
                              }`}
                              disabled={status === "Failed"}
                              aria-label="More options"
                            >
                              <img
                                src={
                                  status === "Failed"
                                    ? DiabledDotMoreOptions
                                    : DotMoreOptions
                                }
                                alt="More Options"
                              />
                            </Menu.Button>
                          </div>
                          {status !== "Failed" && (
                            <Menu.Items
                              className={`flex flex-col text-gray-500 absolute ${
                                detailsList.length === 1 ||
                                (detailsList.length > 1 &&
                                  (index === detailsList.length - 1 ||
                                    index === detailsList.length - 2))
                                  ? "left-10 -top-5   "
                                  : "right-0"
                              } z-10 px-2 text-md w-max origin-top-right rounded-md bg-cfSecondary py-1 shadow-lg ring-1 ring-cfSecondary ring-opacity-5 focus:outline-none`}
                            >
                              <div className="">
                                {/* <hr /> */}
                                <Menu.Item
                                  className="px-2 pb-1 py-2 cursor-pointer"
                                  onClick={() => {
                                    openCloseJsonModal(credential_id);
                                  }}
                                >
                                  <div className="hover:no-underline hover:text-gray-600 text-inherit flex items-center gap-1">
                                    View JSON
                                  </div>
                                </Menu.Item>
                                <hr />
                                <Menu.Item
                                  className={`px-2 pb-1 py-2 ${
                                    status === "Failed" || status === "Revoked"
                                      ? "cursor-not-allowed"
                                      : "cursor-pointer"
                                  }`}
                                  onClick={() => {
                                    setNotificationShowModal(credential_id);
                                  }}
                                  disabled={
                                    status === "Failed" || status === "Revoked"
                                  }
                                >
                                  <div className="hover:no-underline hover:text-gray-600 text-inherit flex items-center gap-1">
                                    Send Notification
                                  </div>
                                </Menu.Item>
                              </div>
                            </Menu.Items>
                          )}
                        </Menu>
                      </div>
                    </td>
                    {isOpen && currentCredentialId === credential_id && (
                      <CredentialPreviewModal
                        credential_id={credential_id}
                        approved_by={approved_by}
                        issuer_name={issuer_name}
                        org_name={org_name}
                        public_verify_url={public_verify_url}
                        email_id={email_id}
                        mobile_number={mobile_number}
                        recipient_name={recipient_name}
                        status={status}
                        updated_at={updated_at}
                        svg_url={svg_url}
                        thumbnail_url={thumbnail_url}
                        whatsapp_number={whatsapp_number}
                        openCloseModal={openCloseModal}
                        isOpen={isOpen}
                        pdf_url={legacy_pdf}
                      />
                    )}
                    {isOpenJSON &&
                      currentCredentialIdJsonModal === credential_id && (
                        <JsonPreviewModal
                          credential_id={credential_id}
                          openCloseModal={openCloseJsonModal}
                          isOpen={isOpenJSON}
                        />
                      )}
                    {credential_id &&
                      notificationShowModal === credential_id && (
                        <NotificationModal
                          ImageUrl={svg_url}
                          Recipient_name={recipient_name}
                          TriggerBtn={notificationShowModal}
                          TriggerBtnToggle={(val) =>
                            setNotificationShowModal(val)
                          }
                          Credential_id={credential_id}
                        />
                      )}
                  </tr>
                )
              )}
            </tbody>
          </table>
        )}
      </div>
      <div className="flex items-center justify-between mt-6 px-8 w-full">
        <button
          onClick={() => GET_ALL_TRANSACTIONS_LIST(limit, offset - limit)}
          className="flex items-center justify-center px-5 py-2 w-36 text-sm active:text-gray-700 capitalize transition-colors duration-200 bg-cfSecondary border rounded-md gap-x-2 hover:bg-gray-100 disabled:text-gray-400"
          disabled={previous === null}
        >
          <span className="flex items-center justify-center gap-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-5 h-5 rtl:-scale-x-100"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18"
              />
            </svg>

            <span>previous</span>
          </span>
        </button>

        <button
          onClick={() => GET_ALL_TRANSACTIONS_LIST(limit, offset + limit)}
          className="flex items-center justify-center px-5 py-2 w-36 text-sm active:text-gray-700 capitalize transition-colors duration-200 bg-cfSecondary border rounded-md gap-x-2 hover:bg-gray-100 disabled:text-gray-400"
          disabled={next === null}
        >
          <span className="flex items-center justify-center gap-2">
            <span>Next</span>

            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-5 h-5 rtl:-scale-x-100"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M17.25 8.25L21 12m0 0l-3.75 3.75M21 12H3"
              />
            </svg>
          </span>
        </button>
      </div>
      {currentPrintCredential && (
        <PrintModal
          isOpen={isPrintModalOpen}
          toggleModal={setIsPrintModalOpen}
          svg_url={currentPrintCredential.svg_url}
          pdf_url={currentPrintCredential.legacy_pdf}
          credential_id={currentPrintCredential.credential_id}
        />
      )}
    </div>
  );
};

export default BatchTransaction;
